import * as React from 'react';
export const IcPhotoFilter = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M21.89 13.42c.067-.47.104-.945.11-1.42a11.01 11.01 0 00-.11-1.42 10 10 0 00-1.36-3.78 10.13 10.13 0 00-3.32-3.32 10 10 0 00-3.78-1.36A10.999 10.999 0 0012 2a11 11 0 00-1.42.11A10 10 0 006.8 3.47a10.13 10.13 0 00-3.33 3.32 10 10 0 00-1.36 3.78A11 11 0 002 12a11 11 0 00.11 1.42 10 10 0 001.36 3.78 10.13 10.13 0 003.32 3.32 10 10 0 003.78 1.36c.473.071.951.111 1.43.12.475-.006.95-.043 1.42-.11a10 10 0 003.78-1.36 10.13 10.13 0 003.32-3.32 10 10 0 001.37-3.79zM17.6 17.7a2 2 0 11.1-.1.47.47 0 01-.1.1zm-11.3-.1a2 2 0 11.1.1.47.47 0 01-.1-.1zM4 12c0-.627.077-1.252.23-1.86a1.9 1.9 0 01.7.45 2 2 0 010 2.82 1.9 1.9 0 01-.7.45A7.58 7.58 0 014 12zm2.4-5.7a2 2 0 11-.1.1l.1-.1zm11.3.1a2 2 0 11-.1-.1.47.47 0 01.1.1zm1.37 7a2 2 0 010-2.82 1.9 1.9 0 01.7-.45 7.64 7.64 0 010 3.72 1.9 1.9 0 01-.7-.44v-.01zm-5.21-9.17a1.9 1.9 0 01-.45.7 2 2 0 01-2.82 0 1.9 1.9 0 01-.45-.7 7.64 7.64 0 013.72 0zm-.45 9.18a2 2 0 11-2.836-2.82 2 2 0 012.836 2.82zm-3.27 6.36a1.9 1.9 0 01.45-.7 2 2 0 012.82 0c.2.197.354.436.45.7a7.64 7.64 0 01-3.72 0z'
      fill='currentColor'
    />
  </svg>
);
